module.exports = __webpack_public_path__ + "static/aplicativoPerformance-e653a32a4af998001ab960086e48364a.png";